import { useEffect } from 'react';

/**
 * הגנה גלובלית מפני שינוי ערך בשדות מספריים בגלילת גלגלת העכבר.
 *
 * בדפדפנים, שדה `<input type="number">` ממוקד משנה את ערכו כשגוללים מעליו
 * עם גלגלת העכבר. זה גורם לתסמין של "מספר שקופץ" — המשתמש מזין ערך, גולל בטופס,
 * והגלגלת משנה בטעות שדה מספרי אחר שהסמן מעליו.
 *
 * ה-hook מתקין listener יחיד ברמת document: ברגע שמתחילים לגלול וה-activeElement
 * הוא שדה מספרי — מסירים ממנו פוקוס (blur), כך שהדפדפן לא משנה את הערך והדף
 * ממשיך לגלול כרגיל. הערך שהוזן נשמר (blur אינו מנקה אותו).
 */
export function useNumberInputWheelGuard(): void {
  useEffect(() => {
    const handleWheel = () => {
      const el = document.activeElement;
      if (el instanceof HTMLInputElement && el.type === 'number') {
        el.blur();
      }
    };

    document.addEventListener('wheel', handleWheel, { passive: true });
    return () => document.removeEventListener('wheel', handleWheel);
  }, []);
}
